/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    query VendorAccounttDirectoryReadQuery($vendorAccounttDirectoryToSearch: String, $take: PositiveInt, $skip: Int) {
      VendorAccounttDirectoryRead(vendorAccounttDirectoryToSearch: $vendorAccounttDirectoryToSearch, take: $take, skip: $skip) {
        id,
        createdAt,
        updatedAt,
        displayName,
        VendorAccountt {
          id
        }
        status,
        message,
        _totalCount
    }
  }
`
